import type { LogicFilterLeaf } from '../../fetchSurvey/types/survey';
import type { LogicContext } from '../types';
import { isAnswerEmpty } from '../fields/isAnswerEmpty';
import { isCustomFieldEmpty } from '../fields/isCustomFieldEmpty';
import { resolveCustomFieldLogicField, resolveQuestionLogicField } from '../fields/resolveLogicField';
import { resolveCustomFieldValue } from '../fields/resolveCustomFieldValue';
import { resolveFieldValue } from '../fields/resolveFieldValue';
import { evaluateOperator } from './evaluateOperator';

export function evaluateLeafFilter(filter: LogicFilterLeaf, context: LogicContext): boolean {
  const entity = filter.details?.conditionEntity;
  const entityType = entity?.entityType;
  const entityId = entity?.id;
  const operator = filter.filterType;
  const values = filter.values ?? [];
  const field = filter.field;

  if (!entityType || !entityId) return false;

  const resolvedField =
    entityType === 'CUSTOM_FIELD'
      ? resolveCustomFieldLogicField(
          field,
          entity.entityType === 'CUSTOM_FIELD' ? entity.fieldType : undefined,
          operator
        )
      : resolveQuestionLogicField(
          field,
          entity.entityType === 'QUESTION' ? entity.answerType : undefined,
          operator,
          values
        );

  if (entityType === 'CUSTOM_FIELD') {
    if (operator === 'MISSING') {
      return isCustomFieldEmpty(resolvedField, entityId, context, filter);
    }

    if (operator === 'EXISTS') {
      return !isCustomFieldEmpty(resolvedField, entityId, context, filter);
    }

    const actual = resolveCustomFieldValue(resolvedField, entityId, context, filter);
    return evaluateOperator(operator, actual, values, resolvedField, undefined, context);
  }

  const questionId = entityType === 'QUESTION' ? entityId : undefined;

  if (operator === 'MISSING') {
    return isAnswerEmpty(resolvedField, questionId, context, values);
  }

  if (operator === 'EXISTS') {
    return !isAnswerEmpty(resolvedField, questionId, context, values);
  }

  const actual = questionId
    ? resolveFieldValue(resolvedField, questionId, context, filter.details?.subConditionEntity?.id)
    : undefined;

  return evaluateOperator(
    operator,
    actual,
    values,
    resolvedField,
    questionId,
    context,
    filter.details?.subConditionEntity?.id
  );
}
